$( document ).ready(function() {
    $('.mainWrapper .t-wrapperHeader .m-search .m-search-button').on('click',function(e){
        $('.m-headerSearchLengDesktop').toggleClass('active');
        e.preventDefault();
    });
    $('#missm-main-navigation button.m-btn-menu').on('click', function(e){
        var liElement = $($(this).closest('li'));
        if (liElement.hasClass('open')) {
            liElement.removeClass('open');
            $(liElement.find('a').first()).attr('aria-expanded', 'false').removeClass('link_active');;
            $(liElement.find('button').first()).attr('aria-expanded', 'false');
        } else {
            liElement.addClass('open');
            liElement.find('a').first().attr('aria-expanded', 'true').addClass('link_active');
            liElement.find('button').first().attr('aria-expanded', 'true');
        }
        e.preventDefault();
    });

    $('.mainWrapper .menu-mobile .accordion .item .item-header .btn-link').on('click', function(e){
        var id = $(this).attr('aria-controls');
        var id_ = id.split('-');
        var id__ = id_[1];
        if($('.mainWrapper .menu-mobile .accordion .item .item-header#item-header-'+id__).hasClass('activo')){
            $('.mainWrapper .menu-mobile .accordion .item .item-header#item-header-'+id__).removeClass('activo');
        } else {
            $('.mainWrapper .menu-mobile .accordion .item .item-header').each(function(){ $(this).removeClass('activo'); });
            $('.mainWrapper .menu-mobile .accordion .item .item-header#item-header-'+id__).addClass('activo');
        }
        e.preventDefault();
    });
    $('.mainWrapper .menu-mobile .accordion .item .item-body .accordion-sub .item-header .btn-link_').on('click', function(e){
        var id = $(this).attr('aria-controls');
        var id_ = id.split('-');
        var id__ = id_[1]+'-'+id_[2];
        if($('.mainWrapper .menu-mobile .accordion .item .item-body .accordion-sub .item-header#item-header-'+id__).hasClass('activo')){
            $('.mainWrapper .menu-mobile .accordion .item .item-body .accordion-sub .item-header#item-header-'+id__).removeClass('activo');
        } else {
            $('.mainWrapper .menu-mobile .accordion .item .item-body .accordion-sub .item-header').each(function(){ $(this).removeClass('activo'); });
            $('.mainWrapper .menu-mobile .accordion .item .item-body .accordion-sub .item-header#item-header-'+id__).addClass('activo');
        }
        e.preventDefault();
    });
    $('.mainWrapper .t-wrapperHeader .m-menuWrapper .m-menuButton').on('click', function(e){
        $('body').addClass('open-menu-mobile');
        e.preventDefault();
    });
    $('.menu-mobile .btn-menu-mobile-close').on('click', function(e){
        $('.mainWrapper .t-wrapperHeader .m-menuWrapper .m-menuButton').trigger('click');
        $('body').removeClass('open-menu-mobile');
        e.preventDefault();
    });
});